import { Region, Language, RidangoReduxAction } from './../ridango.models';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CoreActions {
    static SET_REGION = '[Core]: Set region';
    static SET_SELECTED_LANGUAGE = '[Core]: Set selected language';
    setRegion(payload: Region): RidangoReduxAction {
        return {
            type: CoreActions.SET_REGION,
            payload: payload
        };
    }
    setSelectedLanguage(payload: Language): RidangoReduxAction {
        return {
            type: CoreActions.SET_SELECTED_LANGUAGE,
            payload: payload
        };
    }
}
